import { useMemo } from "react";

import { LabelConfig, LabelMaker } from "../core";

export const useWirelessLabelPrinter = (config?: LabelConfig) => {
  const label = useMemo(() => new LabelMaker(config), [config]);

  return label;
};
